import styled from 'styled-components';

/** The score cards' row: three equal columns 5px apart. Home's Spotlight takes its pick card's width from them (the
 *  ows-ftux prototype's), so the two stay in step. */
export const GAUGE_COLUMNS = 3;
export const GAUGE_GAP_PX = 5;

/** The three score gauges: a tight 3-up grid (stays 3 columns on mobile, the
 *  gauges shrink instead). */
export const Gauges = styled.div`
  display: grid;
  grid-template-columns: repeat(${GAUGE_COLUMNS}, 1fr);
  gap: ${GAUGE_GAP_PX}px;
`;
